import { type DocumentNode, gql } from '@apollo/client';

/**
 * Variables for updatePassword mutation
 */
export interface UpdatePasswordVariables {
  newPassword: string;
  requestId: string;
}

/**
 * Update password payload structure
 */
export interface UpdatePasswordPayload {
  success: boolean;
}

/**
 * Response structure for updatePassword mutation
 */
export interface UpdatePasswordResponse {
  updatePassword: UpdatePasswordPayload;
}

const updatePassword: DocumentNode = gql`
  mutation updatePassword($newPassword: String!, $requestId: UUID!) {
    updatePassword(newPassword: $newPassword, requestId: $requestId) {
      success
    }
  }
`;

export default updatePassword;
